import React, { useContext } from "react";
import { Appcontext, Dispatchcontext } from "./Reducercontext";
import axios from "axios";

const url = "https://eightthsemnewfood.onrender.com";

function Mycart() {
  const usecart = useContext(Appcontext);
  const dispatch = useContext(Dispatchcontext);

  const checkout = async () => {
    const useremail = localStorage.getItem("useremail");
    let curdate = new Date();

    if (!useremail) {
      alert("Please login to continue");
      return;
    }

    if (usecart.length === 0) {
      alert("Cart is empty!");
      return;
    }

    // Clean cart data
    const cleanCart = usecart.map((item) => ({
      name: item.name || "Unknown",
      qty: item.qty || 1,
      size: item.size || "Medium",
      price: item.price || 0,
      img: item.img || "",
      description: item.description || "",
    }));

    try {
      const res = await axios.post(`${url}/cart`, {
        orderdata: cleanCart,
        email: useremail,
        date: curdate,
      });

      // ✅ Fix: check success flag instead of string
      if (res.data=="success") {
        alert("✅ Your order has been received");
        dispatch({ type: "drop" }); // Clear cart
      } else {
        alert("❌ Something went wrong. Try again later.");
      }
    } catch (error) {
      console.error("Checkout failed:", error);
      alert("❌ Failed to place order. Please try again.");
    }
  };

  const totalprice = usecart.reduce((total, food) => total + food.price, 0);

  return (
    <>
      {usecart.length === 0 ? (
        <h1 className="hello">🛒 This cart is empty!</h1>
      ) : (
        <>
          <table className="table">
            <thead>
              <tr className="tr">
                <th className="th">#</th>
                <th className="th">Name</th>
                <th className="th">Quantity</th>
                <th className="th">Option</th>
                <th className="th">Amount</th>
                <th className="th">Action</th>
              </tr>
            </thead>
            <tbody>
              {usecart.map((food, index) => (
                <tr key={index} className="tr">
                  <td>{index + 1}</td>
                  <td>{food.name}</td>
                  <td>{food.qty}</td>
                  <td>{food.size}</td>
                  <td>₹{food.price}</td>
                  <td>
                    <button
                      className="dlte"
                      onClick={() => dispatch({ type: "delete", index })}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          <div className="class">
            <button className="checkout" onClick={checkout}>
              ✅ Check Out
            </button>
            <h1 className="total">TOTAL PRICE: ₹{totalprice}</h1>
          </div>
        </>
      )}
    </>
  );
}

export default Mycart;

